module.exports = __webpack_public_path__ + "static/futurebible-logo-white.adc737e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sponsor-logos/futurebible-logo-white.png
// module id = 149
// module chunks = 114276838955818 192551386620669